<template>
  <div v-if="!hasPermission('List Place Exams')">Você não tem permissão para acessar esta página!</div>
  <div v-else>
    <Toolbar/>

    <div class="container-xxl">
      <div class="col-xl-12 mb-xl-10">
        <div class="card h-md-100">
          <div class="card-body pt-5">
            <ul class="nav nav-pills nav-pills-custom mb-3 d-flex">
              <li class="nav-item mb-3 me-3 me-lg-6" v-for="(kind, index) in kinds" :key="'nav-'+kind.id_kind">
                <a class="nav-link d-flex justify-content-between flex-column flex-center overflow-hidden h-40px py-4"
                   :class="{'active': index === 0}" data-bs-toggle="pill" :href="'#kt_exams_' + kind.id_kind">
                  <span class="nav-text text-gray-700 fw-bolder fs-6 lh-1">{{ kind.kind_name }}</span>
                  <span class="bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"></span>
                </a>
              </li>
              <li class="nav-item mb-3 me-3 me-lg-6">
                <a class="nav-link d-flex justify-content-between flex-column flex-center overflow-hidden h-40px py-4"
                   data-bs-toggle="pill" href="#kt_exams_laboratory">
                  <span class="nav-text text-gray-700 fw-bolder fs-6 lh-1">Exames Laboratoriais</span>
                  <span class="bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"></span>
                </a>
              </li>
              <li class="nav-item mb-3 me-3 me-lg-6">
                <a class="nav-link d-flex justify-content-between flex-column flex-center overflow-hidden h-40px py-4"
                   data-bs-toggle="pill" href="#kt_exams_occupational">
                  <span class="nav-text text-gray-700 fw-bolder fs-6 lh-1">Exames Ocupacional</span>
                  <span class="bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"></span>
                </a>
              </li>
              <li class="nav-item mb-3 me-3 me-lg-6">
                <a class="nav-link d-flex justify-content-between flex-column flex-center overflow-hidden h-40px py-4"
                   data-bs-toggle="pill" href="#kt_vaccines">
                  <span class="nav-text text-gray-700 fw-bolder fs-6 lh-1">Vacinas</span>
                  <span class="bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"></span>
                </a>
              </li>
              <li class="nav-item mb-3 me-3 me-lg-6">
                <a class="nav-link d-flex justify-content-between flex-column flex-center overflow-hidden h-40px py-4"
                   data-bs-toggle="pill" href="#kt_checkups">
                  <span class="nav-text text-gray-700 fw-bolder fs-6 lh-1">Check-ups</span>
                  <span class="bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"></span>
                </a>
              </li>
              <li class="nav-item mb-3 me-3 me-lg-6">
                <a class="nav-link d-flex justify-content-between flex-column flex-center overflow-hidden h-40px py-4"
                   data-bs-toggle="pill" href="#kt_procedures">
                  <span class="nav-text text-gray-700 fw-bolder fs-6 lh-1">Procedimentos</span>
                  <span class="bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"></span>
                </a>
              </li>
              <li class="nav-item mb-3 me-3 me-lg-6">
                <a class="nav-link d-flex justify-content-between flex-column flex-center overflow-hidden h-40px py-4"
                   data-bs-toggle="pill" href="#kt_dentist">
                  <span class="nav-text text-gray-700 fw-bolder fs-6 lh-1">Dentista</span>
                  <span class="bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"></span>
                </a>
              </li>
            </ul>
            <hr>
            <div class="tab-content">

              <div v-for="(kind, index) in kinds" :class="{'active show': index === 0}" :key="kind.id_kind"
                   class="tab-pane fade" :id="'kt_exams_' + kind.id_kind">
                <div class="row">
                  <div class="col-md-10">
                    <input type="text" class="form-control" v-model="searchTerm"
                           placeholder="Pesquisar exame">
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-primary" @click="openModalStore()">
                      Novo Exame
                    </button>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table table-row-bordered align-middle gs-0 gy-4 my-0 table-hover">
                    <thead>
                    <tr class="fw-bold fs-6 text-muted">
                      <th>Nome</th>
                      <th>Ativo?</th>
                      <th>Tem preparo?</th>
                      <th>Ações</th>
                    </tr>
                    </thead>
                    <tbody :key="specialty.id_spec" v-for="specialty in filteredSpecialties(kind.specialties)">
                    <tr>
                      <td>
                         <span class="text-gray-800 fw-bolder text-hover-primary mb-1 fs-6 text-start pe-0">
                           {{ specialty.spec_name }}
                         </span>
                      </td>
                      <td>
                        <span class="badge badge-success" v-if="specialty.active">Sim</span>
                        <span class="badge badge-danger" v-else>Não</span>
                      </td>
                      <td>
                        {{ (specialty.exam_preparation != null || specialty.is_file) ? 'Sim' : 'Não' }}
                      </td>
                      <td>
                        <button class="btn btn-sm btn-outline btn-outline-secondary me-5" type="button"
                                title="Editar exame"
                                @click="onClickEdit(specialty)">
                          <i class="bi bi-pencil"></i>
                        </button>
                        <button class="btn btn-sm btn-outline btn-outline-secondary me-5" type="button"
                                title="Profissionais" @click="managerProfessionals(specialty)">
                          <i class="bi bi-people"></i>
                        </button>
                        <button class="btn btn-sm btn-outline btn-outline-secondary" type="button"
                                title="Excluir exame"
                                @click="deleteExamSpecialty(specialty, kind)">
                          <i class="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>

                </div>
              </div>

              <div class="tab-pane fade" id="kt_exams_laboratory">
                <TabExamLabAndOccup :exams="tabExamsCatalog" type="EXAM-LAB" />
              </div>

              <div class="tab-pane fade" id="kt_exams_occupational">
                <TabExamLabAndOccup :exams="tabExamsCatalog" type="EXAM-OCC" />
              </div>

              <div class="tab-pane fade" id="kt_vaccines">
                <TabExamLabAndOccup :exams="tabExamsCatalog" type="VACCINE" />
              </div>

              <div class="tab-pane fade" id="kt_checkups">
                <TabExamLabAndOccup :exams="tabExamsCatalog" type="CHECKUP" />
              </div>

              <div class="tab-pane fade" id="kt_dentist">
                <TabExamLabAndOccup :exams="tabExamsCatalog" type="DENTIST" />
              </div>

              <div class="tab-pane fade" id="kt_procedures">
                <div class="row">
                  <div class="col-md-10">
                    <input type="text" class="form-control" v-model="searchTermProcedure"
                           placeholder="Pesquisar procedimento">
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-primary" @click="openModalStoreProcedure()">
                      Novo Procedimento
                    </button>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table table-row-bordered align-middle gs-0 gy-4 my-0 table-hover">
                    <thead>
                    <tr class="fw-bold fs-6 text-muted">
                      <th>Nome</th>
                      <th>Ativo?</th>
                      <th>Tem preparo?</th>
                      <th>Ações</th>
                    </tr>
                    </thead>
                    <tbody :key="specialty.id_spec" v-for="specialty in filteredProcedureSpecialties()">
                    <tr>
                      <td>
                         <span class="text-gray-800 fw-bolder text-hover-primary mb-1 fs-6 text-start pe-0">
                           {{ specialty.spec_name }}
                         </span>
                      </td>
                      <td>
                        <span class="badge badge-success" v-if="specialty.active">Sim</span>
                        <span class="badge badge-danger" v-else>Não</span>
                      </td>
                      <td>
                        {{ (specialty.exam_preparation != null || specialty.is_file) ? 'Sim' : 'Não' }}
                      </td>
                      <td>
                        <button class="btn btn-sm btn-outline btn-outline-secondary me-5" type="button"
                                title="Editar procedimento"
                                @click="onClickEditProcedure(specialty)">
                          <i class="bi bi-pencil"></i>
                        </button>
                        <button class="btn btn-sm btn-outline btn-outline-secondary me-5" type="button"
                                title="Profissionais" @click="managerProfessionals(specialty)">
                          <i class="bi bi-people"></i>
                        </button>
                        <button class="btn btn-sm btn-outline btn-outline-secondary" type="button"
                                title="Excluir procedimento"
                                @click="deleteProcedureSpecialty(specialty)">
                          <i class="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ModalProfessionals :specialty="specialty"/>

  <div class="modal fade" tabindex="-1" id="modal_exam">
    <div class="modal-dialog modal-xl">
      <form @submit.prevent="formExam.id_spec ? updateExam() : storeExam()">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ formExam.id_spec ? 'Editar' : 'Novo' }} Exame
            </h5>

            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Fechar">
              <i class="bi bi-x-lg"></i>
            </div>
          </div>
          <div class="modal-body">
            <div class="container">
              <div class="fv-row mb-5">
                <div v-if="formExam?.id_place === place?.id_place" class="row">
                  <div class="col-md-6">
                    <label for="spec_name" class="required form-label">Nome</label>
                    <input type="text" class="form-control form-control-solid"
                           placeholder="Nome do exame..."
                           v-model="formExam.spec_name" id="spec_name" required>
                  </div>
                  <div class="col-md-6">
                    <label for="id_kind" class="required form-label">Tipo</label>
                    <select class="form-control form-control-solid" id="id_kind" required
                            aria-label="Selecione o tipo do exame" v-model="formExam.id_kind">
                      <option :value="kind.id_kind" v-for="kind in kinds">
                        {{ kind.kind_name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-12 mt-2">
                    <label for="id_kind" class="required form-label">Categoria / Área</label>
                    <MultiSelect v-model="formExam.id_spec_group" :options="specGroups" appendTo="self"
                                 :optionLabel="(e) => e.spec_group_name + ' - ' + e.spec_group_description" id="id_spec_group"
                                 :showToggleAll="false" :virtualScrollerOptions="{ itemSize: 44 }" display="chip"
                                 filter :filterFields="['spec_group_name', 'spec_group_description']" placeholder="Selecione"
                                 :maxSelectedLabels="4"
                                 class="form-control form-control-solid w-100 d-flex align-items-center justify-content-end">

                      <template #option="slotProps">
                        <div class="flex align-items-center">
                          <div>{{ slotProps.option.spec_group_name }}</div>
                          <div>{{ slotProps.option.spec_group_description }}</div>
                        </div>
                      </template>

                      <template #footer>
                        <div class="py-2 px-3">
                          <b>{{ formExam.id_spec_group ? formExam.id_spec_group.length : 0 }}</b> Grupo{{ (formExam.id_spec_group ? formExam.id_spec_group.length : 0) > 1 ? 's' : '' }}
                          selecionado{{ (formExam.id_spec_group ? formExam.id_spec_group.length : 0) > 1 ? 's' : '' }}.
                        </div>
                      </template>
                    </MultiSelect>
                  </div>
                  <div class="col-md-12 mt-2">
                    <label for="spec_details" class="form-label">Descrição</label>
                    <textarea class="form-control form-control-solid" placeholder="Descrição do exame"
                              id="spec_details" v-model="formExam.spec_details"></textarea>
                  </div>
                  <div class="col-md-12 mt-2">
                    <label for="tuss" class="required form-label">Código TUSS</label>
                    <MultiSelect v-model="formExam.tuss" :options="tussSelectOptions" appendTo="self"
                                 dataKey="id_exam"
                                 :optionLabel="(e) => e.exam_tuss_code + ' - ' + e.exam_name" id="tuss"
                                 :showToggleAll="false" :virtualScrollerOptions="{ itemSize: 44 }" display="chip"
                                 filter filterPlaceholder="Mín. 2 caracteres (código ou nome)"
                                 :filterFields="['exam_tuss_code', 'exam_name']" placeholder="Busque e selecione"
                                 :maxSelectedLabels="4"
                                 :loading="tussSelectLoading"
                                 emptyMessage="Digite para buscar na tabela TUSS"
                                 emptyFilterMessage="Nenhum resultado para esta busca"
                                 @filter="onTussFilter"
                                 class="form-control form-control-solid w-100 d-flex align-items-center justify-content-end">

                      <template #option="slotProps">
                        <div class="flex align-items-center">
                          <div>{{ slotProps.option.exam_tuss_code }} - {{ slotProps.option.exam_name }}</div>
                        </div>
                      </template>

                      <template #footer>
                        <div class="py-2 px-3">
                          <b>{{ formExam.tuss ? formExam.tuss.length : 0 }}</b> TUSS
                          selecionado{{ (formExam.tuss ? formExam.tuss.length : 0) > 1 ? 's' : '' }}.
                        </div>
                      </template>
                    </MultiSelect>
                  </div>

                  <div class="col-md-8">
                    <br>
                    <div class="mb-3">
                      <label class="form-check-label" for="spec_active">
                        Ativar exame?
                      </label>
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" v-model="formExam.active"
                               role="switch" id="spec_active">

                        <label class="form-check-label">
                          {{ formExam.active ? 'Sim' : 'Não' }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <br>
                    <label for="ps_color" class="form-label">Cor do exame na agenda</label>
                    <input type="color" class="form-control form-control-solid" v-model="formExam.ps_color"
                           id="ps_color">
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <hr>
                    <label for="exam_preparation" class="form-label">Preparo de exames</label>
                    <div class="mb-3">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" v-model="formExam.is_file"
                               @change="onTogglePreparationType()"
                               role="switch" id="upload-file-preparation">
                        <label class="form-check-label" for="upload-file-preparation">
                          Usar um arquivo de preparo
                        </label>
                      </div>
                    </div>

                    <div class="mb-3" v-if="formExam.is_file">
                      <div class="row">
                        <div class="col-md-3 col-xl-2" v-if="formExam.url_exam_preparation">
                          <div class="d-grid gap-2">
                            <label for="exam_preparation_file" class="form-label">
                            </label>
                            <a class="btn btn-primary" target="_blank" :href="formExam.url_exam_preparation">
                              Abrir preparo <i class="bi bi-box-arrow-up-right ms-2"></i>
                            </a>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <label for="exam_preparation_file" class="form-label">
                            Selecione o arquivo de prepapo:
                          </label>
                          <input class="form-control" type="file" accept="application/pdf"
                                 @change="handleFileChange($event)"
                                 placeholder="Selecione o arquivo de preparo"
                                 id="exam_preparation_file">
                          <br>
                        </div>
                      </div>
                    </div>

                    <div class="mb-3" v-else>
                      <label for="exam_preparation" class="form-label">
                        Preparo do Exames:
                      </label>
                      <textarea class="form-control form-control-solid" v-model="formExam.exam_preparation"
                                placeholder="Escreva aqui o prepapo para esse exame."
                                id="exam_preparation" rows="10"></textarea>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
            <button type="submit" class="btn btn-primary">Salvar</button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="modal fade" tabindex="-1" id="modal_procedure">
    <div class="modal-dialog modal-xl">
      <form @submit.prevent="formProcedure.id_spec ? updateProcedure() : storeProcedure()">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ formProcedure.id_spec ? 'Editar' : 'Novo' }} Procedimento
            </h5>

            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Fechar">
              <i class="bi bi-x-lg"></i>
            </div>
          </div>
          <div class="modal-body">
            <div class="container">
              <div class="fv-row mb-5">
                <div v-if="formProcedure?.id_place === place?.id_place" class="row">
                  <div class="col-md-6">
                    <label for="procedure_spec_name" class="required form-label">Nome</label>
                    <input type="text" class="form-control form-control-solid"
                           placeholder="Nome do procedimento..."
                           v-model="formProcedure.spec_name" id="procedure_spec_name" required>
                  </div>
                  <div class="col-md-6">
                    <label for="procedure_id_kind" class="required form-label">Tipo</label>
                    <select class="form-control form-control-solid" id="procedure_id_kind" required
                            aria-label="Selecione o tipo do procedimento" v-model="formProcedure.id_kind">
                      <option :value="kind.id_kind" v-for="kind in procedureKinds">
                        {{ kind.kind_name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-12 mt-2">
                    <label for="procedure_id_kind" class="required form-label">Categoria / Área</label>
                    <MultiSelect v-model="formProcedure.id_spec_group" :options="procedureSpecGroups" appendTo="self"
                                 :optionLabel="(e) => e.spec_group_name + ' - ' + e.spec_group_description" id="procedure_id_spec_group"
                                 :showToggleAll="false" :virtualScrollerOptions="{ itemSize: 44 }" display="chip"
                                 filter :filterFields="['spec_group_name', 'spec_group_description']" placeholder="Selecione"
                                 :maxSelectedLabels="4"
                                 class="form-control form-control-solid w-100 d-flex align-items-center justify-content-end">

                      <template #option="slotProps">
                        <div class="flex align-items-center">
                          <div>{{ slotProps.option.spec_group_name }}</div>
                          <div>{{ slotProps.option.spec_group_description }}</div>
                        </div>
                      </template>

                      <template #footer>
                        <div class="py-2 px-3">
                          <b>{{ formProcedure.id_spec_group ? formProcedure.id_spec_group.length : 0 }}</b> Grupo{{ (formProcedure.id_spec_group ? formProcedure.id_spec_group.length : 0) > 1 ? 's' : '' }}
                          selecionado{{ (formProcedure.id_spec_group ? formProcedure.id_spec_group.length : 0) > 1 ? 's' : '' }}.
                        </div>
                      </template>
                    </MultiSelect>
                  </div>
                  <div class="col-md-12 mt-2">
                    <label for="procedure_spec_details" class="form-label">Descrição</label>
                    <textarea class="form-control form-control-solid" placeholder="Descrição do procedimento"
                              id="procedure_spec_details" v-model="formProcedure.spec_details"></textarea>
                  </div>
                  <div class="col-md-12 mt-2">
                    <label for="procedure_tuss" class="required form-label">Código TUSS</label>
                    <MultiSelect v-model="formProcedure.tuss" :options="tussSelectOptions" appendTo="self"
                                 dataKey="id_exam"
                                 :optionLabel="(e) => e.exam_tuss_code + ' - ' + e.exam_name" id="procedure_tuss"
                                 :showToggleAll="false" :virtualScrollerOptions="{ itemSize: 44 }" display="chip"
                                 filter filterPlaceholder="Mín. 2 caracteres (código ou nome)"
                                 :filterFields="['exam_tuss_code', 'exam_name']" placeholder="Busque e selecione"
                                 :maxSelectedLabels="4"
                                 :loading="tussSelectLoading"
                                 emptyMessage="Digite para buscar na tabela TUSS"
                                 emptyFilterMessage="Nenhum resultado para esta busca"
                                 @filter="onTussFilter"
                                 class="form-control form-control-solid w-100 d-flex align-items-center justify-content-end">

                      <template #option="slotProps">
                        <div class="flex align-items-center">
                          <div>{{ slotProps.option.exam_tuss_code }} - {{ slotProps.option.exam_name }}</div>
                        </div>
                      </template>

                      <template #footer>
                        <div class="py-2 px-3">
                          <b>{{ formProcedure.tuss ? formProcedure.tuss.length : 0 }}</b> TUSS
                          selecionado{{ (formProcedure.tuss ? formProcedure.tuss.length : 0) > 1 ? 's' : '' }}.
                        </div>
                      </template>
                    </MultiSelect>
                  </div>

                  <div class="col-md-8">
                    <br>
                    <div class="mb-3">
                      <label class="form-check-label" for="procedure_spec_active">
                        Ativar procedimento?
                      </label>
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" v-model="formProcedure.active"
                               role="switch" id="procedure_spec_active">

                        <label class="form-check-label">
                          {{ formProcedure.active ? 'Sim' : 'Não' }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <br>
                    <label for="procedure_ps_color" class="form-label">Cor do procedimento na agenda</label>
                    <input type="color" class="form-control form-control-solid" v-model="formProcedure.ps_color"
                           id="procedure_ps_color">
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <hr>
                    <label for="procedure_exam_preparation" class="form-label">Preparo de procedimentos</label>
                    <div class="mb-3">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" v-model="formProcedure.is_file"
                               @change="onTogglePreparationTypeProcedure()"
                               role="switch" id="procedure_upload-file-preparation">
                        <label class="form-check-label" for="procedure_upload-file-preparation">
                          Usar um arquivo de preparo
                        </label>
                      </div>
                    </div>

                    <div class="mb-3" v-if="formProcedure.is_file">
                      <div class="row">
                        <div class="col-md-3 col-xl-2" v-if="formProcedure.url_exam_preparation">
                          <div class="d-grid gap-2">
                            <label for="procedure_exam_preparation_file" class="form-label">
                            </label>
                            <a class="btn btn-primary" target="_blank" :href="formProcedure.url_exam_preparation">
                              Abrir preparo <i class="bi bi-box-arrow-up-right ms-2"></i>
                            </a>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <label for="procedure_exam_preparation_file" class="form-label">
                            Selecione o arquivo de preparo:
                          </label>
                          <input class="form-control" type="file" accept="application/pdf"
                                 @change="handleFileChangeProcedure($event)"
                                 placeholder="Selecione o arquivo de preparo"
                                 id="procedure_exam_preparation_file">
                          <br>
                        </div>
                      </div>
                    </div>

                    <div class="mb-3" v-else>
                      <label for="procedure_exam_preparation" class="form-label">
                        Preparo do Procedimento:
                      </label>
                      <textarea class="form-control form-control-solid" v-model="formProcedure.exam_preparation"
                                placeholder="Escreva aqui o preparo para esse procedimento."
                                id="procedure_exam_preparation" rows="10"></textarea>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
            <button type="submit" class="btn btn-primary">Salvar</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Permission from "../../helpers/permission";
import Toolbar from "../../components/layouts/auth/Toolbar";
import http from "../../helpers/http";
import Alert from "../../helpers/alert";
import Modal from "../../helpers/modal";
import Header from "../../components/layouts/auth/Header.vue";
import MultiSelect from 'primevue/multiselect';
import ModalProfessionals from "./ModalProfessionals.vue";
import TabExamLabAndOccup from "@/views/exams/TabExamLabAndOccup.vue";

export default {
  name: "Exams",
  components: {TabExamLabAndOccup, Header, Toolbar, ModalProfessionals, MultiSelect},
  data() {
    return {
      kinds: [],
      procedureKinds: [],
      tussSelectOptions: [],
      tussSelectLoading: false,
      tussFilterTimer: null,
      tabExamsCatalog: [],
      specGroups: [],
      procedureSpecGroups: [],
      specialty: null,
      searchTerm: '',
      searchTermProcedure: '',
      formExam: {
        id_spec: null,
        spec_name: null,
        spec_details: null,
        active: true,
        is_file: false,
        exam_preparation: null,
        url_exam_preparation: null,
        id_place: null,
        id_kind: '',
        tuss: [],
        id_spec_group: [],
        file: null,
        ps_color: null,
      },
      formProcedure: {
        id_spec: null,
        spec_name: null,
        spec_details: null,
        active: true,
        is_file: false,
        exam_preparation: null,
        url_exam_preparation: null,
        id_place: null,
        id_kind: '',
        tuss: [],
        id_spec_group: [],
        file: null,
        ps_color: null,
      },
    }
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
  },
  mounted() {
    this.getKinds();
    this.getProcedureKinds();
    this.loadTabExamsCatalog();
    this.getSpecialtyGroups();
    this.getProcedureSpecialtyGroups();
  },
  beforeUnmount() {
    if (this.tussFilterTimer) {
      clearTimeout(this.tussFilterTimer);
    }
  },
  methods: {
    hasPermission(permission) {
      return Permission.has(permission);
    },
    filteredSpecialties(specialties) {
      if (!this.searchTerm) {
        return specialties;
      }

      return specialties.filter(specialty =>
        specialty.spec_name.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    },
    filteredProcedureSpecialties() {
      let allSpecialties = [];
      this.procedureKinds.forEach(kind => {
        if (kind.specialties) {
          allSpecialties = allSpecialties.concat(kind.specialties);
        }
      });

      if (!this.searchTermProcedure) {
        return allSpecialties;
      }

      return allSpecialties.filter(specialty =>
        specialty.spec_name.toLowerCase().includes(this.searchTermProcedure.toLowerCase())
      );
    },
    onTogglePreparationType() {
      if (this.formExam.is_file) {
        this.formExam.exam_preparation = null;
      } else {
        this.formExam.file = null;
      }
    },
    onTogglePreparationTypeProcedure() {
      if (this.formProcedure.is_file) {
        this.formProcedure.exam_preparation = null;
      } else {
        this.formProcedure.file = null;
      }
    },
    handleFileChange(event) {
      this.formExam.file = event.target.files[0];
    },
    handleFileChangeProcedure(event) {
      this.formProcedure.file = event.target.files[0];
    },
    getKinds() {
      http.get(`/places/${this.place.id_place}/kinds/exams`, {params: {with_specialties: true}}).then((response) => {
        this.kinds = response.data;
      });
    },
    getProcedureKinds() {
      http.get(`/places/${this.place.id_place}/kinds/procedures`, {params: {with_specialties: true}}).then((response) => {
        this.procedureKinds = response.data;
      }).catch(() => {
        // Se não existir endpoint específico, tentar buscar como exams mas filtrar
        this.procedureKinds = [];
      });
    },
    loadTabExamsCatalog() {
      http.get('/exams').then((response) => {
        this.tabExamsCatalog = response.data || [];
      });
    },
    resetTussSelectPanel() {
      this.tussSelectOptions = [];
      this.tussSelectLoading = false;
      if (this.tussFilterTimer) {
        clearTimeout(this.tussFilterTimer);
        this.tussFilterTimer = null;
      }
    },
    onTussFilter(event) {
      const q = String(event.value ?? '').trim();
      if (this.tussFilterTimer) {
        clearTimeout(this.tussFilterTimer);
      }
      if (q.length < 2) {
        this.tussSelectOptions = [];
        return;
      }
      this.tussFilterTimer = setTimeout(() => {
        this.tussSelectLoading = true;
        http.get('/exams', { params: { search: q } })
          .then((response) => {
            this.tussSelectOptions = response.data || [];
          })
          .catch(() => {
            this.tussSelectOptions = [];
          })
          .finally(() => {
            this.tussSelectLoading = false;
          });
      }, 300);
    },
    getSpecialtyGroups() {
      http.get(`/specialty-groups`, {params: {kind_exam: true, kind_procedure: false}}).then((response) => {
        this.specGroups = response.data;
      });
    },
    getProcedureSpecialtyGroups() {
      http.get(`/specialty-groups`, {params: {kind_exam: false, kind_procedure: true}}).then((response) => {
        this.procedureSpecGroups = response.data;
      });
    },
    deleteExamSpecialty(specialty, kind) {
      Swal.fire({
        title: 'Heeyy',
        text: "Tem certeza que deseja remover o exame?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.delete(`/places/${this.place.id_place}/kinds/${kind.id_kind}/exams/${specialty.id_spec}`)
            .then(() => {
              this.getKinds();
              Alert.success('Exame excluído com sucesso.');
            })
            .catch((e) => {
              Alert.error(e.response?.data?.message ?? e.response?.data ?? 'Erro ao excluir exame.');
            });
        }
      });
    },
    openModalStore() {
      this.resetTussSelectPanel();
      this.formExam = {
        exam_preparation: null,
        id_kind: null,
        tuss: [],
        spec_name: null,
        spec_details: null,
        active: true,
        is_file: false,
        id_place: this.place.id_place,
        url_exam_preparation: null,
        ps_color: null,
        id_spec_group: [],
      };

      if (this.kinds.length === 1) {
        this.formExam.id_kind = this.kinds[0].id_kind;
      }

      Modal.toggle('#modal_exam');
    },
    managerProfessionals(specialty) {
      this.specialty = specialty;

      setTimeout(() => Modal.toggle('#modal_professionals'), 200);
    },
    onClickEdit(specialty) {
      this.resetTussSelectPanel();
      if (document.getElementById('exam_preparation_file'))
        document.getElementById('exam_preparation_file').value = null;

      this.formExam.file = null;
      this.formExam = {
        id_kind: specialty.id_kind,
        tuss: [],
        id_spec: specialty.id_spec,
        spec_name: specialty.spec_name,
        spec_details: specialty.spec_details?.replace('null', ''),
        active: specialty.active,
        is_file: specialty.is_file,
        exam_preparation: specialty.exam_preparation,
        url_exam_preparation: specialty.url_exam_preparation,
        id_place: specialty.id_place,
        ps_color: specialty.ps_color,
        id_spec_group: [],
      };

      this.formExam.tuss = specialty.exams.map(({place_spec_exam, ...rest}) => rest);
      this.formExam.id_spec_group = specialty.spec_groups.map(({spec_groups, ...rest}) => rest);

      Modal.toggle('#modal_exam');
    },
    updateExam() {
      const formData = new FormData();
      formData.append('_method', 'put');
      formData.append('spec_name', this.formExam.spec_name);
      formData.append('spec_details', this.formExam.spec_details);
      formData.append('active', this.formExam.active);
      formData.append('id_place', this.formExam.id_place);
      formData.append('id_kind', this.formExam.id_kind);
      formData.append('ps_color', this.formExam.ps_color);
      this.formExam.tuss.forEach(tussItem => formData.append('tuss[]', tussItem.id_exam));
      this.formExam.id_spec_group.forEach(specGroup => formData.append('id_spec_group[]', specGroup.id_spec_group));

      if (this.formExam.exam_preparation)
        formData.append('exam_preparation', this.formExam.exam_preparation);

      if (this.formExam.file)
        formData.append('file', this.formExam.file);

      http.post(`/places/${this.place.id_place}/kinds/${this.formExam.id_kind}/exams/${this.formExam.id_spec}`, formData)
        .then(() => {
          this.getKinds();
          Alert.success('Exame salvo com sucesso.');
          Modal.toggle('#modal_exam');
        }).catch(() => Alert.error('Erro ao salvar exame.'));
    },
    storeExam() {
      const formData = new FormData();
      formData.append('spec_name', this.formExam.spec_name);
      formData.append('spec_details', this.formExam.spec_details);
      formData.append('active', this.formExam.active);
      formData.append('id_place', this.formExam.id_place);
      formData.append('id_kind', this.formExam.id_kind);
      formData.append('ps_color', this.formExam.ps_color);
      formData.append('id_spec_group', this.formExam.id_spec_group);
      this.formExam.tuss.forEach(tussItem => formData.append('tuss[]', tussItem.id_exam));
      this.formExam.id_spec_group.forEach(specGroup => formData.append('id_spec_group[]', specGroup.id_spec_group));

      if (this.formExam.exam_preparation)
        formData.append('exam_preparation', this.formExam.exam_preparation);

      if (this.formExam.file)
        formData.append('file', this.formExam.file);

      http.post(`/places/${this.place.id_place}/kinds/${this.formExam.id_kind}/exams`, formData)
        .then(() => {
          this.getKinds();
          Alert.success('Exame salvo com sucesso.');
          Modal.toggle('#modal_exam');
        }).catch(() => Alert.error('Erro ao salvar exame.'));
    },
    openModalStoreProcedure() {
      this.resetTussSelectPanel();
      this.formProcedure = {
        exam_preparation: null,
        id_kind: null,
        tuss: [],
        spec_name: null,
        spec_details: null,
        active: true,
        is_file: false,
        id_place: this.place.id_place,
        url_exam_preparation: null,
        ps_color: null,
        id_spec_group: [],
      };

      if (this.procedureKinds.length === 1) {
        this.formProcedure.id_kind = this.procedureKinds[0].id_kind;
      }

      Modal.toggle('#modal_procedure');
    },
    deleteProcedureSpecialty(specialty) {
      Swal.fire({
        title: 'Heeyy',
        text: "Tem certeza que deseja remover o procedimento?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.delete(`/places/${this.place.id_place}/kinds/${specialty.id_kind}/procedures/${specialty.id_spec}`)
            .then(() => {
              this.getProcedureKinds();
              Alert.success('Procedimento excluído com sucesso.');
            })
            .catch((e) => {
              Alert.error(e.response?.data?.message ?? e.response?.data ?? 'Erro ao excluir procedimento.');
            });
        }
      });
    },
    onClickEditProcedure(specialty) {
      this.resetTussSelectPanel();
      if (document.getElementById('procedure_preparation_file'))
        document.getElementById('procedure_preparation_file').value = null;

      this.formProcedure.file = null;
      this.formProcedure = {
        id_kind: specialty.id_kind,
        tuss: [],
        id_spec: specialty.id_spec,
        spec_name: specialty.spec_name,
        spec_details: specialty.spec_details?.replace('null', ''),
        active: specialty.active,
        is_file: specialty.is_file,
        exam_preparation: specialty.exam_preparation,
        url_exam_preparation: specialty.url_exam_preparation,
        id_place: specialty.id_place,
        ps_color: specialty.ps_color,
        id_spec_group: [],
      };

      this.formProcedure.tuss = specialty.exams.map(({place_spec_exam, ...rest}) => rest);
      this.formProcedure.id_spec_group = specialty.spec_groups.map(({spec_groups, ...rest}) => rest);

      Modal.toggle('#modal_procedure');
    },
    updateProcedure() {
      const formData = new FormData();
      formData.append('_method', 'put');
      formData.append('spec_name', this.formProcedure.spec_name);
      formData.append('spec_details', this.formProcedure.spec_details);
      formData.append('active', this.formProcedure.active);
      formData.append('id_place', this.formProcedure.id_place);
      formData.append('id_kind', this.formProcedure.id_kind);
      formData.append('ps_color', this.formProcedure.ps_color);
      this.formProcedure.tuss.forEach(tussItem => formData.append('tuss[]', tussItem.id_exam));
      this.formProcedure.id_spec_group.forEach(specGroup => formData.append('id_spec_group[]', specGroup.id_spec_group));

      if (this.formProcedure.exam_preparation)
        formData.append('exam_preparation', this.formProcedure.exam_preparation);

      if (this.formProcedure.file)
        formData.append('file', this.formProcedure.file);

      http.post(`/places/${this.place.id_place}/kinds/${this.formProcedure.id_kind}/procedures/${this.formProcedure.id_spec}`, formData)
        .then(() => {
          this.getProcedureKinds();
          Alert.success('Procedimento salvo com sucesso.');
          Modal.toggle('#modal_procedure');
        }).catch(() => Alert.error('Erro ao salvar procedimento.'));
    },
    storeProcedure() {
      const formData = new FormData();
      formData.append('spec_name', this.formProcedure.spec_name);
      formData.append('spec_details', this.formProcedure.spec_details);
      formData.append('active', this.formProcedure.active);
      formData.append('id_place', this.formProcedure.id_place);
      formData.append('id_kind', this.formProcedure.id_kind);
      formData.append('ps_color', this.formProcedure.ps_color);
      formData.append('id_spec_group', this.formProcedure.id_spec_group);
      this.formProcedure.tuss.forEach(tussItem => formData.append('tuss[]', tussItem.id_exam));
      this.formProcedure.id_spec_group.forEach(specGroup => formData.append('id_spec_group[]', specGroup.id_spec_group));

      if (this.formProcedure.exam_preparation)
        formData.append('exam_preparation', this.formProcedure.exam_preparation);

      if (this.formProcedure.file)
        formData.append('file', this.formProcedure.file);

      http.post(`/places/${this.place.id_place}/kinds/${this.formProcedure.id_kind}/procedures`, formData)
        .then(() => {
          this.getProcedureKinds();
          Alert.success('Procedimento salvo com sucesso.');
          Modal.toggle('#modal_procedure');
        }).catch(() => Alert.error('Erro ao salvar procedimento.'));
    },
  }
}
</script>

<style scoped>

</style>